export default __webpack_public_path__ + "static/media/r77-coin.5cdcae18.svg";